<template>
  <PageWrap
    :heading="$t('promote.nav.links.pricing_widget')"
    :loading="loading"
  >
    <BaseText :mb="2">{{ $t('admin.pricing_widget.description') }}</BaseText>
    <BaseCard
      :mb="2"
      :heading="$t('global.settings')"
    >
      <BaseForm @submit="updateColor">
        <div :class="$style.inputs">
          <BaseInput
            v-model="width"
            type="number"
            :label="$t('admin.pricing_widget.settings.width')"
            v-test="'pricing-widget-width'"
          />
          <BaseInput
            v-model="height"
            type="number"
            :label="$t('admin.pricing_widget.settings.height')"
            v-test="'pricing-widget-height'"
          />
          <div>
            <BaseInputLabel :text="$t('admin.pricing_widget.settings.color')" />
            <BaseColorLabel
              v-model="color"
              large
              colorPicker
              v-test="'pricing-widget-color'"
            />
          </div>
        </div>
        <Flex justify="end">
          <BaseButton
            submitForm
            v-test="'pricing-widget-save'"
          >
            {{ $t('global.actions.save') }}
          </BaseButton>
        </Flex>
      </BaseForm>
    </BaseCard>
    <BaseCard
      :mb="2"
      :heading="$t('global.widget_code')"
    >
      <BaseText mb>{{ $t('admin.pricing_widget.heading_snippet') }}:</BaseText>
      <BaseCodeField
        :code="snippetCode"
        v-test="'pricing-widget-snippet'"
      />
    </BaseCard>
    <BaseCard :heading="$t('global.preview')">
      <iframe
        :class="$style.iframe"
        :src="widgetUrl"
        v-test="'pricing-widget-preview'"
      />
    </BaseCard>
  </PageWrap>
</template>

<script
  setup
  lang="ts"
>
import { useStorage } from '@vueuse/core';
import { storeToRefs } from 'pinia';
import { computed, ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import { flash } from '@/helpers/ui';
import PageWrap from '@/modules/admin/PageWrap.vue';
import { useMicroSiteStore } from '@/stores/micro-site';

const {
  microSite,
  servicesWidgetUrl: widgetUrl,
  loading,
} = storeToRefs(useMicroSiteStore());
const { updateMicroSite } = useMicroSiteStore();
const width = useStorage('pricing_widget_width', 400);
const height = useStorage('pricing_widget_height', 600);
const color = ref('');
watch(
  microSite,
  () => {
    color.value = microSite.value?.baseColor || '';
  },
  { immediate: true },
);

const snippetCode = computed(
  () =>
    `<iframe src="${widgetUrl.value}" style="width: 100%; max-width: ${width.value}px; height: ${height.value}px; border: none;"></iframe>`,
);

const { t } = useI18n();
const updateColor = () => {
  updateMicroSite({
    baseColor: color.value,
  }).then(() => {
    flash(t('global.flash.settings_saved'));
  });
};
</script>

<style
  lang="scss"
  module
>
.inputs {
  display: flex;
  flex-wrap: wrap;

  & > * {
    margin-bottom: $spacing;

    &:not(:last-child) {
      margin-right: $spacing;
    }
  }
}

.iframe {
  border: 0;
  width: 100%;
  height: 600px;
  background-color: white;
}
</style>
